<ng-template let-extraClass="extraClass" #topNav>
  @if (!windowService.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Order TIDY Sensor'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    <ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }" />

    @if (windowService.isDesktopRes) {
      <tidy-desktop-header>
        <div class="wrappable-container">
          <tidy-image
            [src]="'assets/svg/arrow-back-black.svg'"
            (action)="goBack()"
            class="desktop-back-icon" />
          <tidy-text [title]="'Order TIDY Sensor'" />
        </div>
      </tidy-desktop-header>
    }

    <tidy-card>
      <tidy-row [align]="'center'">
        <tidy-image
          [src]="'assets/img/tidy-wifi-noise-sensor.png'"
          style="width: 80px; height: 80px; border-radius: 8px; margin-right: 16px; object-fit: contain;" />
        <div>
          <tidy-text [header]="'TIDY Wi-Fi & Noise Sensor'" /><br>
          <tidy-text [body]="'2-in-1 device: noise monitoring + Wi-Fi access point. $250 per sensor, including tax and shipping.'" />
        </div>
      </tidy-row>
    </tidy-card>

    <!--@if (propertiesMissingCount > 0) {
      <tidy-card>
        <tidy-row>
          <tidy-checkbox
            [(checked)]="addToAllMissing"
            [items]="[{viewValue: 'Add to all properties missing a sensor (' + propertiesMissingCount + ')', value: 'all'}]" />
        </tidy-row>
      </tidy-card>
    }-->

    @if (!addToAllMissing) {
      <tidy-card>
        <form [formGroup]="form">
          <tidy-select
            [label]="'Which property?'"
            [form]="form.controls.property"
            formControlName="property"
            [items]="propertyItems"
            [icon]="'assets/svg/home-outline.svg'"
            [submitted]="submitted"
            [errorMessage]="'Please select a property'" />

          <tidy-select
            [label]="'How many sensors?'"
            [form]="form.controls.quantity"
            formControlName="quantity"
            [items]="quantityItems"
            [icon]="'assets/svg/list.svg'" />
        </form>
      </tidy-card>
    }

    @if (errorMessage) {
      <tidy-error-message [text]="errorMessage" />
    }

    <tidy-button
      [text]="isSubmitting ? 'Submitting...' : 'Order Sensor'"
      [action]="boundSubmitOrder"
      class="primary"
      [disabled]="isSubmitting" />
  </tidy-wrapper>
</ng-template>

<app-scroll-wrapper
  [isfullWidthContent]="windowService.isDesktopRes"
  [templateContent]="content" />
